import { render } from "./login.vue?vue&type=template&id=1289cca3"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__